import { Button, Heading, Text } from '@frontend/design-system';
import * as styles from './not-found.styles';

export const NotFound = () => {
  return (
    <main className={styles.notFoundPageStyles}>
      <div className={styles.notFoundContentStyles}>
        <Heading level={2}>Page not found</Heading>
        <Text color='light'>The page you requested does not exist.</Text>
        <Button onClick={() => (window.location.href = '/dashboard')}>Go to Dashboard</Button>
      </div>
    </main>
  );
};
